// ----------- ACTION NAMES

const SET_FOO = 'SET_FOO';
const INC_FOO = 'INC_FOO';
const actions = [SET_FOO, INC_FOO];

// ------------ ACTIONS

const mutators = new Map();

function makeAction(type, mutator) {
  mutators.set(type, mutator);
  return payload => ({
    type,
    payload,
  });
}

const setFoo = makeAction(SET_FOO, (state = {}, foo) => ({
  ...state,
  foo,
}));

const incFoo = makeAction(INC_FOO, (state = {}) => ({
  ...state,
  foo: state.foo + 1,
}));

const providers = {
  setFoo,
  incFoo,
};

// -------------- RESOLVER

const initialValue = { foo: 1 };
const resolver = (state = initialValue, { type, payload }) => {
  if (!mutators.has(type)) {
    return state;
  }

  return mutators.get(type)(state, payload);
};

export { actions, providers, mutators, INC_FOO, SET_FOO, setFoo, incFoo };

export default resolver;
